import React from 'react';
import { LinkOnComponent } from 'app/components/links/link';
import { StreamTeaserImage } from 'app/components/stream/streamTeaserImage';
import NewsActivityHeader from 'app/components/district/news/NewsActivityHeader';
import { ImageEntity } from '@fupa/fupa-uikit';
import ActivityTitle from 'app/components/district/common/ActivityTitle';
import { Wrapper } from 'app/components/district/common/ActivityStyles';
export default function NewsActivity(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "NewsActivity",
    "data-sentry-source-file": "NewsActivity.tsx"
  }, /*#__PURE__*/React.createElement(NewsActivityHeader, {
    subject: data.subject,
    publishDate: data.formatDateRelative(),
    "data-sentry-element": "NewsActivityHeader",
    "data-sentry-source-file": "NewsActivity.tsx"
  }), /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: data.getLink(),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "NewsActivity.tsx"
  }, /*#__PURE__*/React.createElement(StreamTeaserImage, {
    entity: ImageEntity.News,
    image: data.news.image,
    isHero: false,
    "data-sentry-element": "StreamTeaserImage",
    "data-sentry-source-file": "NewsActivity.tsx"
  }), /*#__PURE__*/React.createElement(ActivityTitle, {
    title: data.news.title,
    "data-sentry-element": "ActivityTitle",
    "data-sentry-source-file": "NewsActivity.tsx"
  })));
}